<template>
  <modal-provider :fullscreen-breakpoint="768" name="shop-card-modal" :width="900" @before-open="beforeOpen">
    <ShopCard is-adaptive is-info-modal :shop-data="shopData" />
  </modal-provider>
</template>

<script>
import ShopCard from './ShopCard'

export default {
  name: 'ShopCardModal',
  components: { ShopCard },
  data () {
    return {
      shopData: {}
    }
  },
  methods: {
    beforeOpen (event) {
      this.shopData = event.params && event.params.shopData ? event.params.shopData : {}
    }
  }
}
</script>

<style scoped lang="sass">
::v-deep
  .modal-body
    padding: 0
  .modal-heading
    padding: 0
    min-height: 0

  .modal__close
    top: 11px
    right: 11px
    width: 32px
    height: 32px
    border-radius: 50%
    background-color: #f8f8f8
    opacity: 1

    &:before,
    &:after
      width: 14px
      height: 1px

    &:before
      top: 50%
      left: 50%
      transform: translate(-50%, -50%) rotate(-45deg)

    &:after
      top: 50%
      left: 50%
      transform: translate(-50%, -50%) rotate(45deg)
</style>
